import { Component, Input, OnInit } from '@angular/core';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-tutoriel-video-player',
    templateUrl: './tutoriel-video-player.component.html',
    styleUrls: ['./tutoriel-video-player.component.scss'],
    imports: []
})
export class TutorielVideoPlayerComponent implements OnInit {
  @Input() vimeoId!: string;
  @Input() titre?: string;

  vimeoUrl: SafeResourceUrl | null = null;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.vimeoId) {
      this.vimeoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://player.vimeo.com/video/${this.vimeoId}?title=1&byline=1&portrait=0`
      );
    }
  }
}
